import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-dashboard-tab6',
  templateUrl: './admin-dashboard-tab6.component.html',
  styleUrls: ['./admin-dashboard-tab6.component.scss']
})
export class AdminDashboardTab6Component implements OnInit {

  rights = [ "First Name", "Last Name", "Email", "Permission 1", "Permission 2", "Permission 3", "Permission 4", "Permission 5", "Permission 6", "Select User" ]
  rowsRights = [
    {
      "First Name" : "John",
      "Last Name" : "Doe",
      "Email" : "johndoe@gmail.com",
      "Permission 1" : "Yes",
      "Permission 2" : "Yes",
      "Permission 3" : "No",
      "Permission 4" : "No",
      "Permission 5" : "Yes",
      "Permission 6" : "No",
      "Select User" : ""
    },
    {
      "First Name" : "John",
      "Last Name" : "Doe",
      "Email" : "johndoe@gmail.com",
      "Permission 1" : "Yes",
      "Permission 2" : "Yes",
      "Permission 3" : "No",
      "Permission 4" : "No",
      "Permission 5" : "Yes",
      "Permission 6" : "No",
      "Select User" : ""
    },
    {
      "First Name" : "John",
      "Last Name" : "Doe",
      "Email" : "johndoe@gmail.com",
      "Permission 1" : "Yes",
      "Permission 2" : "Yes",
      "Permission 3" : "No",
      "Permission 4" : "No",
      "Permission 5" : "Yes",
      "Permission 6" : "No",
      "Select User" : ""
    },
    {
      "First Name" : "John",
      "Last Name" : "Doe",
      "Email" : "johndoe@gmail.com",
      "Permission 1" : "Yes",
      "Permission 2" : "Yes",
      "Permission 3" : "No",
      "Permission 4" : "No",
      "Permission 5" : "Yes",
      "Permission 6" : "No",
      "Select User" : ""
    },
    {
      "First Name" : "John",
      "Last Name" : "Doe",
      "Email" : "johndoe@gmail.com",
      "Permission 1" : "Yes",
      "Permission 2" : "Yes",
      "Permission 3" : "No",
      "Permission 4" : "No",
      "Permission 5" : "Yes",
      "Permission 6" : "No",
      "Select User" : ""
    },
    {
      "First Name" : "John",
      "Last Name" : "Doe",
      "Email" : "johndoe@gmail.com",
      "Permission 1" : "Yes",
      "Permission 2" : "Yes",
      "Permission 3" : "No",
      "Permission 4" : "No",
      "Permission 5" : "Yes",
      "Permission 6" : "No",
      "Select User" : ""
    }
  ]

  constructor() { }

  ngOnInit() {
  }

}
